import { clientPortalApi } from "./clientPortal";

const CACHE_CONTROL = "public, max-age=31536000, immutable";

async function signOne(file, { prefix = "portal-cliente" } = {}) {
  const { data } = await clientPortalApi.post("/portal-cliente/uploads/sign", {
    filename: file.name,
    contentType: file.type || "application/octet-stream",
    prefix,
  });
  const signed = data?.data || data;
  if (!signed?.uploadUrl || !signed?.fileUrl) {
    throw Object.assign(new Error("Não foi possível preparar o envio do arquivo."), {
      isPortalClientError: true,
    });
  }
  return signed;
}

async function putToS3(uploadUrl, file) {
  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || "application/octet-stream",
      "Cache-Control": CACHE_CONTROL,
    },
    body: file,
  });
  if (!res.ok) {
    throw Object.assign(
      new Error("Não foi possível enviar o arquivo. Tente um arquivo menor ou outro formato."),
      { isPortalClientError: true }
    );
  }
}

export async function portalUploadOne(file, opts = {}) {
  const { uploadUrl, fileUrl, key } = await signOne(file, opts);
  await putToS3(uploadUrl, file);
  return { url: fileUrl, key };
}

export function inferPortalFileMessageType(file) {
  const t = String(file?.type || "");
  if (t.startsWith("image/")) return "image";
  if (t.startsWith("video/")) return "video";
  return "file";
}
